import { TablePaymentLinks } from './styles'

import { useNavigate } from 'react-router-dom'
import { BiDollarCircle } from 'react-icons/bi'
import { RiExchangeDollarLine } from 'react-icons/ri'
import { cnpjCpfMask, parseDate } from '../../utils/masks'
import dayjs from '../../libs/dayjs'
import { HiOutlineReceiptPercent } from 'react-icons/hi2'

interface Props {
    paidPaymentLinks: any[]
}
const PaidForYou = ({ paidPaymentLinks }: Props) => {
    const navigate = useNavigate()

    function renderRowsPaidLinks() {
        return paidPaymentLinks?.map((link: any) => {
            return (
                <tr key={link.id}>
                    <td
                        onClick={() =>
                            navigate(
                                `/cobranca/${link.id}?criadorCobranca=false`
                            )
                        }
                    >
                        {dayjs(link.createdAt).format('DD/MM/YYYY - HH:mm:ss')}
                    </td>
                    <td
                        onClick={() =>
                            navigate(
                                `/cobranca/${link.id}?criadorCobranca=false`
                            )
                        }
                    >
                        {link.nomeTitular}
                    </td>
                    <td
                        onClick={() =>
                            navigate(
                                `/cobranca/${link.id}?criadorCobranca=false`
                            )
                        }
                    >
                        {cnpjCpfMask(link.numeroDocumentoTitular)}
                    </td>
                    <td
                        onClick={() =>
                            navigate(
                                `/cobranca/${link.id}?criadorCobranca=false`
                            )
                        }
                    >
                        {parseDate(link.dataLiquidacao, true)}
                    </td>
                    <td
                        onClick={() =>
                            navigate(
                                `/cobranca/${link.id}?criadorCobranca=false`
                            )
                        }
                    >
                        {Number(link.valor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </td>
                    {/* <td onClick={() => navigate(`/link/${link.id}?criadorCobranca=false`)} >{link.quantParcelas} parcelas</td> */}
                    {/* <td onClick={() => navigate(`/link/${link.id}?criadorCobranca=false`)} >{link.situacao}</td> */}
                    <td
                        className="tipo"
                        onClick={() =>
                            navigate(
                                `/cobranca/${link.id}?criadorCobranca=false`
                            )
                        }
                    >
                        {link.tipoLink === 0 && (
                            <BiDollarCircle color="#333" size={22} />
                        )}
                        {link.tipoLink === 1 && (
                            <RiExchangeDollarLine color="#333" size={22} />
                        )}
                        {link.tipoLink === 2 && (
                            <HiOutlineReceiptPercent color="#333" size={22} />
                        )}
                    </td>
                </tr>
            )
        })
    }
    return (
        <TablePaymentLinks>
            <thead>
                <tr>
                    <th>Data de criação</th>
                    <th>Recebedor</th>
                    <th>
                        CPF/CNPJ <br />
                        (Quem recebe)
                    </th>
                    <th>Data liquidação</th>
                    <th>Valor</th>
                    {/* <th>N. Parcelas</th> */}
                    {/* <th>Situação</th> */}
                    <th>Tipo</th>
                </tr>
            </thead>

            <tbody>{renderRowsPaidLinks()}</tbody>
        </TablePaymentLinks>
    )
}

export default PaidForYou
